// This is just the name of the key which will correspond to the secure session token
// in local storage. 
export const AUTH_TOKEN_KEY = 'yourzengiftAuthToken';
